/**
 * Rellena el segmento "colección" en breadcrumbs PDP cuando Shopify no expone `collection`
 * (p. ej. URL /products/...). Usa sessionStorage guardado en páginas de colección, o referrer.
 */
const STORAGE_KEY = 'onne_last_collection';

function humanizeHandle(handle) {
  if (!handle) return '';
  return handle
    .split('-')
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ');
}

function syncSeparators(root, middleLi) {
  const sepAfterHome = root.querySelector('[data-pdp-breadcrumbs-sep-after-home]');
  const sepBeforeCurrent = root.querySelector('[data-pdp-breadcrumbs-sep-before-current]');
  const currentLi = root.querySelector('[data-pdp-breadcrumbs-current]');
  const middleHasLink =
    middleLi && !middleLi.hidden && middleLi.querySelector('a[data-pdp-breadcrumbs-collection-link], a.pdp-breadcrumbs__link');
  const hasCurrent = Boolean(currentLi && !currentLi.hidden);

  if (sepAfterHome) {
    sepAfterHome.hidden = !(middleHasLink || hasCurrent);
  }
  if (sepBeforeCurrent) {
    sepBeforeCurrent.hidden = !middleHasLink || !hasCurrent;
  }
}

function initNav(root) {
  const middleLi = root.querySelector('[data-pdp-breadcrumbs-middle]');
  const sepBeforeCurrent = root.querySelector('[data-pdp-breadcrumbs-sep-before-current]');
  if (!middleLi) return;

  const hasLiquid = middleLi.querySelector('a[data-pdp-breadcrumbs-collection-link]');
  if (hasLiquid) {
    if (sepBeforeCurrent) sepBeforeCurrent.hidden = false;
    syncSeparators(root, middleLi);
    return;
  }

  let url = '';
  let title = '';

  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw) {
      const d = JSON.parse(raw);
      if (d && typeof d.url === 'string' && d.title) {
        url = d.url;
        title = String(d.title);
      }
    }
  } catch {
    /* ignore */
  }

  if (!url && root.dataset.referrerFallback === 'true') {
    try {
      const ref = document.referrer ? new URL(document.referrer) : null;
      if (
        ref &&
        ref.origin === location.origin &&
        /\/collections\//.test(ref.pathname) &&
        !/\/products\//.test(ref.pathname)
      ) {
        url = ref.pathname + ref.search;
        const handle = ref.pathname.replace(/^\/collections\//, '').split('/')[0];
        title = humanizeHandle(handle);
      }
    } catch {
      /* ignore */
    }
  }

  if (!url && root.dataset.fallbackCatalogUrl) {
    url = root.dataset.fallbackCatalogUrl;
    title = root.dataset.fallbackCatalogLabel || '';
  }

  if (url && title) {
    const a = document.createElement('a');
    a.className = 'pdp-breadcrumbs__link';
    a.href = url;
    a.textContent = title;
    middleLi.textContent = '';
    middleLi.appendChild(a);
    middleLi.hidden = false;
    if (sepBeforeCurrent) sepBeforeCurrent.hidden = false;
  } else {
    middleLi.innerHTML = '';
    middleLi.hidden = true;
    if (sepBeforeCurrent) sepBeforeCurrent.hidden = true;
  }

  syncSeparators(root, middleLi);
}

function run() {
  document.querySelectorAll('[data-pdp-breadcrumbs]').forEach(initNav);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', run, { once: true });
} else {
  run();
}
